// extracted by mini-css-extract-plugin
export default {"infoBox":"AppContent_infoBox__LppqP","copyBox":"AppContent_copyBox__KX3FM","copyIcon":"AppContent_copyIcon__ah8jr","shake":"AppContent_shake__TL1iW"};